import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

var config = {
  apiKey: 'AIzaSyBl5VMMFLaxbQ9IJ2RWrgu-63HTmUFfKeY',
  authDomain: 'bmg-omg.firebaseapp.com',
  databaseURL: 'https://bmg-omg.firebaseio.com',
  projectId: 'bmg-omg',
  storageBucket: 'bmg-omg.appspot.com',
  messagingSenderId: '385758602399',
};

firebase.initializeApp(config);

export default firebase;
